import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Standard cn() — clsx + tailwind-merge so utility-classes resolve correctly. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
